import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=50e6b3e7&scoped=true"
import script from "./mailbox.vue?vue&type=script&lang=js"
export * from "./mailbox.vue?vue&type=script&lang=js"
import style0 from "./mailbox.vue?vue&type=style&index=0&id=50e6b3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6b3e7",
  null
  
)

export default component.exports